import React from "react"
import PropTypes from "prop-types"
import authentication from "@irati/auth"
import Hr from "@irati/ui/src/Layout/Hr"
import {H3} from "@irati/ui/src/Typography/Heading"
import {Para} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"
import {ButtonsWrapper, SkipForNow, NextStep} from "../styled/Buttons"
import {SlideWrapper} from "../styled/Slider"

const Step1 = ({onNext, onSkip}) => {
  const user = authentication.user()
  const tenant = authentication.userTenant()

  return (
    <SlideWrapper>
      <header>
        <H3 className="text-center">
          <FormattedMessage id="recognition.onboarding.step1.header" values={{firstname: user.firstname}} />
        </H3>
        <Hr />
      </header>
      <section>
        <Para>
          <FormattedMessage id="recognition.onboarding.step1.p1" />
        </Para>
        <Para>
          <FormattedMessage id="recognition.onboarding.step1.p2" values={{tenantName: tenant.public_name}} />
        </Para>
        <Para>
          <FormattedMessage id="recognition.onboarding.step1.p3" />
        </Para>
      </section>
      <ButtonsWrapper>
        <Hr />
        <NextStep onClick={onNext} />
        <SkipForNow onClick={onSkip} />
      </ButtonsWrapper>
    </SlideWrapper>
  )
}

Step1.propTypes = {
  onNext: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired
}

export default Step1
